var map = {
  "./bialystok.png": "72173",
  "./bydgoszcz.png": "29939",
  "./gdansk.png": "21320",
  "./gdynia.png": "31990",
  "./gliwice.png": "56887",
  "./katowice.png": "45348",
  "./kielce.png": "19089",
  "./krakow.png": "55054",
  "./lodz.png": "18503",
  "./lublin.png": "17000",
  "./olsztyn.png": "86768",
  "./opole.png": "41273",
  "./poznan.png": "69900",
  "./rzeszow.png": "76232",
  "./szczecin.png": "14992",
  "./torun.png": "83321",
  "./warszawa.png": "24060",
  "./wroclaw.png": "73067"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16471;
